import React from "react";
import Loadable from "../../react-loadable";

const WeaTagGroup = Loadable({
  loader: () => import("./TagGroup"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaTagGroup;



// WEBPACK FOOTER //
// ./ecology9/wea-tag-group/index.js